<template>
  <div class="footer">
    <div class="footer-up">
      <div class="footer-up-sub">
        <div class="footer-up-item">
          <h3>政府支持</h3>
          <div v-for="supItem in govSup" :key="supItem.index">{{supItem.govName}}</div>
        </div>
        <div class="footer-up-item">
          <h3>联系我们</h3>
          <div class="imgCup" v-for="(usItem,index) in footerUs" :key='index'>
            <img :src="usItem.icon" alt="">
            <span>&nbsp;&nbsp;{{usItem.text}}</span>
          </div>
        </div>
        <div class="footer-up-item">
          <h3>数据平台</h3>
          <div class="paltForm">
            <div class="paltForm-sub">
              <el-link href="http://www.yg.chiaic.com" :underline="false" target="_blank">
                <img :src=imgBag.vehicle alt="平台图标">
                <div class="f_ptname">智能农机装备管理平台</div>
              </el-link>
            </div>
            <div class="paltForm-sub">
              <el-link href="http://zhny.chiaic.com" :underline="false" target="_blank">
                <img :src=imgBag.vehicle alt="">
                <div class="f_ptname">智慧农业管理平台</div>
              </el-link>
            </div>
            <div class="paltForm-sub" @click="viewPt(3)">
              <img :src=imgBag.dimCode alt="二维码">
              <div class="f_ptname">神农耘耕APP下载</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-down">
      <div class="footer-sub">
        <div>2019 © IAMEA 版权所有&nbsp;&nbsp;<el-link :href="beian" target="_blank" type="primary" :underline="false">豫ICP备 19000234号</el-link>
        </div>
        <!-- <div style="margin-top:6px;">
          <img src="../../../static/img/footer/police.png" alt="">
          <span>测试标签备XXXXXXXXXXXXXX 号</span>
        </div> -->
      </div>
    </div>
  </div>
</template>
<script>
import { homeCommonData } from '@/api/frontApi/frontHome';
import IMGGROUPS from '@/common/util/imgBus';
export default {
  data() {
    return {
      govSup: [],
      contactUs: null,
      beian: 'http://www.beian.miit.gov.cn/',
      footerUs: [
        {
          text: '0379 - 60199639',
          icon: IMGGROUPS.footer.phone
        },
        {
          text: '471934',
          icon: IMGGROUPS.footer.mail1
        },
        {
          text: 'lyhiaic@163.com',
          icon: IMGGROUPS.footer.mail2
        },
        {
          text: '洛阳市 伊滨区 科技大道21号 中意科技园409室',
          icon: IMGGROUPS.footer.address
        }
      ],
      imgBag: {
        vehicle: IMGGROUPS.footerTractor,
        dimCode: IMGGROUPS.dimCode
      }
    };
  },
  created() {
    this.getSupport();
    this.getContactUs();
  },
  methods: {
    getSupport() {
      homeCommonData({ pageNo: 1, pageSize: 100, commonType: 4 }).then(res => {
        for (let i = 0; i < res.data.records.length; i++) {
          let tempObj = { govName: '', index: 0 };
          tempObj.govName = res.data.records[i].commonName;
          tempObj.index = i;
          this.govSup.push(tempObj);
        }
      });
    },
    getContactUs() {
      homeCommonData({ pageNo: 1, pageSize: 100, commonType: 5 }).then(res => {
        // this.firstP = res.data.records[0].commonText;
      });
    }
  }
};
</script>
<style scoped>
.footer {
  width: 100%;
  background-color: #fff;
}
.footer-up {
  background-image: url('../../../static/img/footer/footer.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  height: 300px;
  width: 100%;
  color: #bfbfbf;
}
.footer-up-sub {
  overflow: hiidden;
  margin-left: 15%;
  padding-top: 50px;
}
.footer-up-sub .footer-up-item {
  float: left;
  margin-right: 10%;
}
.footer-up-item div {
  margin-top: 20px;
}
.imgCup img {
  margin-top: -8px;
}
.footer-down {
  background-color: #fff;
  text-align: center;
  width: 80%;
  height: 60px;
  color: #515151;
  padding-top: 20px;
  padding-left: 10%;
}

img {
  vertical-align: middle;
}
.paltForm {
  overflow: hidden;
}
.paltForm-sub {
  float: left;
  margin-right: 30px;
}
.paltForm-sub img {
  margin-left: 13%;
}
.f_ptname {
  color: #f2f6fc;
}
</style>



// WEBPACK FOOTER //
// src/common/area/footer.vue